var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgW4WLogoMark = function SvgW4WLogoMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 341 218.1"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96.5 180.6l-17.9-54.3H59.3l-17.9 54.3-16.5-54H0l.9 2.7L31 218.1h19.6l18.1-52.5 18.1 52.5h19.6l31-91.5h-24.3zm220.1-54l-16.5 54-17.9-54.3h-19.4l-17.9 54.3-16.5-54h-24.9l1 2.7 30.1 88.8h19.6l18.1-52.5 18.1 52.5h19.5l31.1-91.5zM153.2 198a17.4 17.4 0 0034.8 0c.3-14.8-17.4-20.9-17.4-35 0 14.2-17.4 19.4-17.4 35z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M245.7 22.3a43.28 43.28 0 00-43.2 43.2v1.8h24.7v-1.8A18.5 18.5 0 11245.7 84l-60.7.2V0h-25.5L84.1 87.3v21.4h72l.1 41H185l-.1-41 60.7.1a43.25 43.25 0 00.1-86.5zm-89.6 61.9h-36.5l36.5-42.8z"
  })));
};
export default SvgW4WLogoMark;